import { capitalizeFirstLetter } from '@/helpers/string'

export function parseAndFillContact({
  givenName,
  familyName,
  addressLines = [],
  locality,
  postalCode,
  phoneNumber,
  countryCode,
  administrativeArea,
  subLocality,
  // -- Not used yet --
  // country,
  // subAdministrativeArea,
  // subLocality,
}) {
  const attrs = {
    firstname: givenName || 'NAME',
    lastname: familyName || 'SURNAME',
    address1: addressLines[0] || 'STREET ADDRESS',
    address2: addressLines[1] || '',
    zipcode: postalCode,
    city: locality,
    phone: phoneNumber || '0771234455',
    country: { iso: countryCode },
    state: { name: administrativeArea },
    // TODO: Refine fields
    gender: 'm',
  }
  if (countryCode.toLowerCase() === 'br') {
    return {
      ...attrs,
      neighborhood: subLocality,
      ibge_city_code: 'IBGE CITY CODE',
      document_number: 'DOC NUMBER',
    }
  }
  return attrs
}

export function parseAddressErrors(errors, { shippingOnly }) {
  const parsedErrors = Object.keys(errors || [])
    .map(errorKey => {
      const errorValue = errors[errorKey][0]
      const match = errorKey.match(/(\w+)\.(\w+)/i)

      if (match.length !== 3) {
        throw new Error(`Unknown validation error: ${errorValue}`)
      }

      const errorType = match[1]
      const errorField = match[2]
      const isShipping = errorType === 'ship_address'
      const isBilling = errorType === 'bill_address'

      if (shippingOnly && !isShipping) {
        return null
      }
      if (!isShipping && !isBilling) {
        throw new Error(`Unknown validation error: ${errorType}`)
      }

      const code = isShipping ? 'shippingContactInvalid' : 'billingContactInvalid'
      const prefix = errorField === 'base' ? '' : errorField.replace(/_/g, ' ')
      const errorMessage = `${prefix} ${errorValue}`

      return {
        code,
        contactField: 'postalAddress',
        message: capitalizeFirstLetter(errorMessage),
      }
    })
    .filter(error => error !== null)

  return parsedErrors.map(
    error => new window.ApplePayError(error.code, error.contactField, error.message)
  )
}

export function hasSameAddress(shipping, billing) {
  const commonFields = [
    'addressLines',
    'administrativeArea',
    'country',
    'countryCode',
    'familyName',
    'givenName',
    'locality',
    'postalCode',
    'subAdministrativeArea',
    'subLocality',
  ]
  const haveSameValues = (lastAnswer, field) => {
    const answer = shipping[field] === billing[field]
    return answer === false ? false : Boolean(lastAnswer)
  }
  return commonFields.reduce(haveSameValues, false)
}
